import {createContext, useContext, useState, ReactNode} from 'react';
import {ParamsRefStatsData} from "../state/models/UserResponse.ts";

export type ModalType =
    | 'WARNING'
    | 'DECLINE_PUBLICATION'
    | 'PAYMENT'
    | 'SHARE'
    | 'SEARCH'
    | 'CHANNEL_DETAILS'
    | 'AVAILABLE_CHANNELS'
    | 'STOP_CAMPAIGN'
    | 'STATISTICS_PLACEMENT'
    | 'REFERRAL_STATS_FILTER'
    | 'LAUNCH_CAMPAIGN'
    | 'DECLINE_ACTUAL_PUBLICATION'
    | 'TIME_PICKER'
    | 'REFERRAL_PROGRAM_TERMS'

export type ModalInstance = {
    id: string; // Уникальный ID модалки
    type: ModalType;
    props: ModalPropsType;
};

export type ModalPropsType = {
    isOpen: boolean;
    onConfirm?: () => void;
    onClose: () => void;
    title?: string;
    desc?: string;
    searchType?: "allChannels" | "createCampaign"
    stopCampaignType?: "stop" | "start"
    applyFilters?: (payload: ParamsRefStatsData) => void;
    modalId?: string; // 👈 добавь это
    [key: string]: any;
};

interface ModalContextProps {
    openModal: (type: ModalType, props?: Omit<ModalPropsType, 'onClose'>) => void;
    closeModal: (id: string) => void;
    modals: ModalInstance[];
}

const ModalContext = createContext<ModalContextProps | undefined>(undefined);

export const ModalProvider = ({children}: { children: ReactNode }) => {
    const [modals, setModals] = useState<ModalInstance[]>([]);

    const openModal = (type: ModalType, props?: Omit<ModalPropsType, 'onClose'> & { onClose?: () => void }) => {
        const id = crypto.randomUUID();
        const userOnClose = props?.onClose;

        const modal: ModalInstance = {
            id,
            type,
            props: {
                ...props,
                isOpen: true,
                onClose: () => {
                    userOnClose?.();
                    setTimeout(() => {
                        closeModal(id);     // потом закрытие модалки
                    }, 700)// сначала пользовательская логика
                },
            },
        };

        setModals((prev) => [...prev, modal]);
    };


    const closeModal = (id: string) => {
        setModals((prev) => prev.filter((modal) => modal.id !== id));
    };

    return (
        <ModalContext.Provider value={{modals, openModal, closeModal}}>
            {children}
        </ModalContext.Provider>
    );
};

export const useModal = () => {
    const context = useContext(ModalContext);
    if (!context) {
        throw new Error('useModal must be used within a ModalProvider');
    }
    return context;
};
